import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center text-xl" }
const _hoisted_2 = { class: "font-bold" }

import debounce from 'lodash/debounce';
import { onMounted, ref, watch } from 'vue';
import { useRouterCustom } from '@/core/hooks/use-router-custom';
import { usePagination } from '@/core/hooks/use-pagination';
import { BienBanGiaiTheService } from '@/core/services/BienBanGiaiThe.service';
import { useLoading } from '@/core/hooks/use-loading';
import { usePageHeader } from '@/core/hooks/usePageHeader';
import { swalErrNotification, swalNotification } from '@/core/helpers/utils';
import { IBienBanGiaiTheResponseBase } from '@/core/interfaces/ApiResponses';

import BienBanGiaiTheTable from '@/components/shared/bien-ban-giai-the-table/BienBanGiaiTheTable.vue';
import PageContentBase from '@/layout/_shared/PageContentBase.vue';
import Pagination from '@/components/shared/pagination/Pagination.vue';
import ConfirmationDialog from '@/components/confirmation-dialog/ConfirmationDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

document.title = 'Phê duyệt biên bản giải thể - Đường sắt Hà Nội';

const { push } = useRouterCustom();
const { startLoading, endLoading } = useLoading();
const { currentPage, totalItems, perPage } = usePagination();

const items = ref<IBienBanGiaiTheResponseBase[]>([]);
const isConfirmDeleteDialogDisplay = ref(false);
const selectedBienBanForDelete = ref<IBienBanGiaiTheResponseBase | null>(null);

const { searchQuery } = usePageHeader({
  title: 'Phê duyệt biên bản giải thể',
  breadcrumbs: [
    { text: 'Phê duyệt' },
    { text: 'Biên bản giải thể' },
  ],
  showSearch: true,
  searchPlaceholder: 'Nhập để tìm kiếm',
});

onMounted(async () => {
  await fetchBienBanGiaiTheItems();
});

watch(
  () => currentPage.value,
  () => {
    fetchBienBanGiaiTheItems();
  }
);

watch(
  () => perPage.value,
  () => {
    if (currentPage.value === 1) {
      fetchBienBanGiaiTheItems();
      return;
    }
    currentPage.value = 1;
  }
);

watch(searchQuery, debounce(() => {
  fetchBienBanGiaiTheItems();
}, 500));

const fetchBienBanGiaiTheItems = async () => {
  try {
    await startLoading();

    const {
      data: {
        data: { data, total },
      },
    } = await BienBanGiaiTheService.listPendingApproval({
      current_page: currentPage.value,
      per_page: perPage.value,
      ...(searchQuery.value && { searchTerm: searchQuery.value }),
    });

    items.value = data;
    totalItems.value = total;

    await endLoading();
  } catch (error) {
    await endLoading();
    await swalErrNotification(
      error,
      'Có lỗi xảy ra khi lấy danh sách biên bản giải thể'
    );
  }
};

const onDeleteHandler = ({
  item,
}: {
  id: number;
  item: IBienBanGiaiTheResponseBase;
}) => {
  selectedBienBanForDelete.value = item;
  isConfirmDeleteDialogDisplay.value = true;
};

const confirmDelete = async () => {
  if (!selectedBienBanForDelete.value) return;

  const bienBanToDelete = selectedBienBanForDelete.value;
  isConfirmDeleteDialogDisplay.value = false;
  selectedBienBanForDelete.value = null;

  try {
    await startLoading();

    await BienBanGiaiTheService.delete(bienBanToDelete.id);

    await swalNotification(
      `Xóa biên bản số ${bienBanToDelete.so_bien_ban} thành công`,
      'success'
    );

    await fetchBienBanGiaiTheItems();

    endLoading();
  } catch (e) {
    endLoading();
    await swalErrNotification(e, 'Có lỗi xảy ra khi xóa biên bản');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ConfirmationDialog, {
      title: "Xác nhận",
      size: "sm",
      "is-display": isConfirmDeleteDialogDisplay.value,
      onOnConfirmButtonClick: confirmDelete,
      onOnCloseButtonClick: _cache[0] || (_cache[0] = ($event: any) => (isConfirmDeleteDialogDisplay.value = false)),
      onOnCloseIconClick: _cache[1] || (_cache[1] = ($event: any) => (isConfirmDeleteDialogDisplay.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("h4", _hoisted_1, [
          _createTextVNode(" Bạn có chắc chắn muốn xóa BBGT số "),
          _createElementVNode("span", _hoisted_2, _toDisplayString(selectedBienBanForDelete.value?.so_bien_ban), 1),
          _createTextVNode("? ")
        ])
      ]),
      _: 1
    }, 8, ["is-display"]),
    _createVNode(PageContentBase, null, {
      default: _withCtx(() => [
        _createVNode(BienBanGiaiTheTable, {
          "is-ke-hoach-column-displaying": true,
          items: items.value,
          "is-hoan-thanh-button-displayed": false,
          "show-approval-buttons": true,
          "show-delete-button": true,
          "on-success": fetchBienBanGiaiTheItems,
          onOnDetailClick: _cache[2] || (_cache[2] = 
        ({ id }) => _unref(push)(`/quan-ly/bien-ban-giai-the/chi-tiet/${id}`)
      ),
          onOnEditClick: _cache[3] || (_cache[3] = 
        ({ id }) => _unref(push)(`/quan-ly/bien-ban-giai-the/cap-nhat/${id}`)
      ),
          onOnDeleteClick: onDeleteHandler,
          "cur-page": _unref(currentPage),
          "per-page": _unref(perPage)
        }, null, 8, ["items", "cur-page", "per-page"]),
        (items.value.length > 0)
          ? (_openBlock(), _createBlock(Pagination, {
              key: 0,
              page: _unref(currentPage),
              total: _unref(totalItems),
              onChangePage: _cache[4] || (_cache[4] = (value) => (currentPage.value = value)),
              onChangePageSize: _cache[5] || (_cache[5] = (value) => (perPage.value = value))
            }, null, 8, ["page", "total"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})